pxco.Modal = function (options) {
	var modal = this;

	modal = pxco.extend({
		el: '',
		title: '',
		target: '',
		isDynamic: false,
		isVisible: false,
		size: 'default',
		close: function () {
			pxco.build.Modal.close(modal);
		},
		setTarget: function (target) {
			pxco.build.Modal.setTarget(modal, target);
			return this;
		},
		open: function () {
			pxco.build.Modal.open(modal);
		},
		listen: function (eventName, callback) {
			pxco.events.listen(modal, eventName, callback);
		},
		events: {}
	}, options);

	pxco.build.Modal.init(modal);

	return modal;
};

pxco.build.Modal = {
	prefix: 'pxModal',
	//init modal
	init: function (modal) {
		if (!modal)
			return false;
		
		modal.prefix = this.prefix;
		
		if (modal.target.slice(0, 1) !== '#' || modal.target == '') {
			modal.el = this.create(modal);
			modal.isDynamic = true;
		} else {
			modal.el = document.querySelector(modal.target);
		}

		this.setTitle(modal);

		this.closeBtn(modal);
		
		pxco.events.get(modal, this.prefix);
	},
	// open modal
	open: function (modal) {
		
		if (modal.isDynamic)
			document.body.appendChild(modal.el);	

		modal.el.classList.add(this.prefix + '_show');
		modal.isVisible = true;

		document.body.classList.add(this.prefix + '_opened');

		pxco.events.set(modal, this.prefix + ':opened');
	},
	// create modal
	create: function (options) {
		if (!options)
			return false;
		
		var modal;
		
		modal = document.createElement('div');

		var iframe = document.createElement('iframe');
		iframe.setAttribute('border', '0');
		iframe.setAttribute('scrolling', 'yes');
		iframe.setAttribute('frameborder', '0');
		iframe.setAttribute('src', options.target);

		modal.appendChild(iframe);

		modal.classList.add(this.prefix);
		modal.classList.add(this.prefix + '_' + options.size);
		
		return modal;
	},
	// close modal
	close: function (modal) {
		var el = modal.el ? modal.el : document.querySelector('.' + this.prefix);
		
		if (!el)
			return false;
		
		el.classList.remove(this.prefix + '_show');
		
		document.body.classList.remove(this.prefix + '_opened');

		if (modal.isDynamic)
			document.body.removeChild(el);
		
		modal.isVisible = false;
		
		pxco.events.set(modal, this.prefix + ':closed');
	},
	// close btn
	closeBtn: function (modal) {
		var me = this;

		var close = document.createElement('a');
		close.setAttribute('href', '#');
		close.setAttribute('data-modal-close', '');
		close.innerHTML = '&times;';
	
		modal.el.appendChild(close);

		close.onclick = function (e) {
			e.preventDefault();
			me.close(modal);
		};
	},
	// create btn
	createBtn: function () {
		var me = this;

		var modal = document.querySelectorAll('[data-modal]');
		for (var i = 0; i < modal.length; ++i) {
			modal[i].onclick = function (e) {
				e.preventDefault();
				var target = this.getAttribute('[data-modal]');
				me.init({ target: target });
			};
		}
	},
	// modal title
	setTitle: function (modal) {
		if (!modal.title)
			return false;
		
		var t = document.createElement('h4');
		t.classList.add('pxModal_title');
		t.innerHTML = modal.title;

		modal.el.insertBefore(t, modal.el.firstChild);
		
		return modal;
	},
	setTarget: function (modal, target) {
		if (!modal.isDynamic)
			return false;
		
		var iframe = modal.el.querySelector('iframe');
		iframe.src = target;

		return modal;
	}
};